import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-overview-status-v2',
    templateUrl: './overview-status-v2.component.html',
    styleUrls: ['./overview-status-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OverviewStatusV2Component {
@Input() statusData;
@Input() statusDetails;
  constructor(public translate: TranslateService) { }

}
